module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Fields":"Fields","Content":"Content","Layout":"Layout"},"de":{"Fields":"Felder","Content":"Inhalt","Layout":"Layout"}}')
  delete Component.options._Ctor
}
